<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-text class="pt-4 prompt-text">{{ text }}</v-card-text>
      <v-card-text v-if="input" class="pt-0">
        <v-text-field
          v-model="input_value"
          :label="input.label"
          :maxlength="input.maxlength || 255"
          dense
          outlined
          hide-details
          autofocus
          @keydown.enter="handleClick(buttons[0] && buttons[0].value)"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-for="(button, index) in buttons"
          :key="index"
          color="primary"
          text
          @click="handleClick(button.value)"
        >
          {{ button.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PromptDialog',
  data() {
    return {
      dialog: false,
      text: '',
      buttons: [],
      input: null,
      input_value: '',
      resolve: null,
      reject: null
    }
  },
  methods: {
    open(options) {
      this.dialog = true
      this.text = options.text || ''
      this.buttons = options.buttons || [{ text: 'OK', value: { ok: true } }]
      // Optional free text field: { label, value, maxlength }. The typed text comes back as `input` on the resolved value.
      this.input = options.input || null
      this.input_value = (options.input && options.input.value) || ''
      
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    handleClick(value) {
      this.dialog = false
      if (this.resolve) {
        this.resolve(this.input && value && typeof value === 'object' ? { ...value, input: this.input_value } : value)
      }
    }
  },
  beforeDestroy() {
    // Clean up to prevent memory leaks
    this.resolve = null
    this.reject = null
  }
}
</script>

<style scoped>
.prompt-text {
  white-space: pre-line;
}
</style>
